export class ChangeShowBackgroundImage {
   public static readonly type = '[UserStatusBrickSettings] Change Show Background Image';

   constructor(public brickInstanceId, public show: boolean) {}
}

export class ChangeShowUsername {
   public static readonly type = '[UserStatusBrickSettings] Change Show Username';

   constructor(public brickInstanceId, public show: boolean) {}
}

export class ChangeShowPrivateDn {
   public static readonly type = '[UserStatusBrickSettings] Change Private Dn';

   constructor(public brickInstanceId, public show: boolean) {}
}

export class ChangeShowAvatar {
   public static readonly type = '[UserStatusBrickSettings] Change Show Avatar';

   constructor(public brickInstanceId, public show: boolean) {}
}

export class ChangeShowAlternativeDeviceEditor {
   public static readonly type = '[UserStatusBrickSettings] Change Show Alternative Device Editor';

   constructor(public brickInstanceId, public show: boolean) {}
}

export class ChangeShowStatusDropdown {
   public static readonly type = '[UserStatusBrickSettings] Change Show Status Dropdown';

   constructor(public brickInstanceId, public show: boolean) {}
}
